import React from 'react'
import { StateProvider } from './src/state/provider'
import ScreenManager from './src/screens/ScreenManager'

export default function App() {
  return (
    <StateProvider>
      <ScreenManager />
    </StateProvider>
  )
}
// import { StatusBar } from 'expo-status-bar';
// import React from 'react';
// import { StyleSheet, Text, View } from 'react-native';

// export default function App() {
//   return (
//     <View style={styles.container}>
//       <Text>Open up App.js to start working on your app!</Text>
//       <StatusBar style="auto" />
//     </View>
//   );
// }

// const styles = StyleSheet.create({
//   container: {
//     flex: 1,
//     backgroundColor: '#fff',
//     alignItems: 'center',
//     justifyContent: 'center',
//   },
// });
